/* Local dependencies */
import { Device } from '../../types';
import { Device as DeviceType } from '../../types';
import { DeviceActionTypes } from './reducer';

export const listDevice = () => {
  return {
    type: DeviceActionTypes.LIST_DEVICE_REQUEST,
  };
};

export const listDevicesSuccess = (devices: Device[]) => ({
  type: DeviceActionTypes.LIST_DEVICE_SUCCESS,
  payload: devices,
});

export const listDevicesFailure = (error: string) => ({
  type: DeviceActionTypes.LIST_DEVICE_FAILURE,
  payload: error,
});

export const searchDevices = (searchTerm: string) => ({
  type: DeviceActionTypes.SEARCH_DEVICES,
  payload: searchTerm,
});

export const selectDevice = (device: DeviceType) => ({
  type: DeviceActionTypes.SELECT_DEVICE,
  payload: device,
});
